import analytics from '@s-ui/segment-wrapper'

import triggerPixels from './pixels/index.js'

// Apply filters for any destination in these wrapped methods.
// Also trigger those pixels we can't migrate to Segment by now.
const track = async (event, properties = {}, context = {}, callback) => {
  await analytics.track(event, properties, context, callback)
  await triggerPixels({event, properties, isPage: false})
}
const page = async (event, properties = {}, context = {}, callback) => {
  await analytics.page(event, properties, context, callback)
  await triggerPixels({event, properties, isPage: true})
}

export default {...analytics, track, page}
